import { MouseEventHandler, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import Footer from "../components/Footer";
import DFNavbar from "../components/Navbar";
import dfscanner_icon from "./../img/dfscanner/icon.png";
import dfscanner_icon_lite from "./../img/dfscanner/icon_lite.png";
import dfviewer_icon from "./../img/dfviewer/icon.jpg";
import dflat_icon from "./../img/dflat/icon.png";
import dflat_icon_lite from "./../img/dflat/icon_lite.png";
import dfwalker_icon from "./../img/dfwalker/icon.png";
import dfbird_icon from "./../img/dfbird/icon.png";
import { ScrollToTop } from "../components/ScrollToTop";
import { PRODUCT_SELECT_ROUTE, RELEASE_NOTES_ROUTE } from "../consts/routes";
import {
    AI_SEGMENTATION_MODEL_FILENAME,
    AI_SEGMENTATION_MODEL_URL,
    DF_BIRD_FILENAME,
    DF_BIRD_LICENSE_URL,
    DF_BIRD_MANUAL_EN_FILENAME,
    DF_BIRD_MANUAL_EN_URL,
    DF_BIRD_MANUAL_JA_FILENAME,
    DF_BIRD_MANUAL_JA_URL,
    DF_BIRD_URL,
    DF_LAT_LITE_FILENAME,
    DF_LAT_LITE_MANUAL_EN_FILENAME,
    DF_LAT_LITE_MANUAL_EN_URL,
    DF_LAT_LITE_MANUAL_JA_FILENAME,
    DF_LAT_LITE_MANUAL_JA_URL,
    DF_LAT_LITE_TERMS_OF_USE_EN_URL,
    DF_LAT_LITE_TERMS_OF_USE_JA_URL,
    DF_LAT_LITE_URL,
    DF_LAT_PRO_FILENAME,
    DF_LAT_PRO_MANUAL_EN_FILENAME,
    DF_LAT_PRO_MANUAL_EN_URL,
    DF_LAT_PRO_MANUAL_JA_FILENAME,
    DF_LAT_PRO_MANUAL_JA_URL,
    DF_LAT_PRO_TERMS_OF_USE_EN_URL,
    DF_LAT_PRO_TERMS_OF_USE_JA_URL,
    DF_LAT_PRO_URL,
    DF_SCANNER_FILENAME,
    DF_SCANNER_LITE_FILENAME,
    DF_SCANNER_LITE_MANUAL_EN_FILENAME,
    DF_SCANNER_LITE_MANUAL_EN_URL,
    DF_SCANNER_LITE_MANUAL_JA_FILENAME,
    DF_SCANNER_LITE_MANUAL_JA_URL,
    DF_SCANNER_LITE_TERMS_OF_USE_EN_URL,
    DF_SCANNER_LITE_TERMS_OF_USE_JA_URL,
    DF_SCANNER_LITE_URL,
    DF_SCANNER_PRO_FILENAME,
    DF_SCANNER_PRO_MANUAL_EN_FILENAME,
    DF_SCANNER_PRO_MANUAL_EN_URL,
    DF_SCANNER_PRO_MANUAL_JA_FILENAME,
    DF_SCANNER_PRO_MANUAL_JA_URL,
    DF_SCANNER_PRO_TERMS_OF_USE_EN_URL,
    DF_SCANNER_PRO_TERMS_OF_USE_JA_URL,
    DF_SCANNER_PRO_URL,
    DF_SCANNER_TESTDATA_FILENAME,
    DF_SCANNER_TESTDATA_URL,
    DF_SCANNER_URL,
    DF_VIEWER_FILENAME,
    DF_VIEWER_MANUAL_JA_FILENAME,
    DF_VIEWER_MANUAL_JA_URL,
    DF_VIEWER_TERMS_OF_USE_EN_URL,
    DF_VIEWER_TERMS_OF_USE_JA_URL,
    DF_VIEWER_URL,
    DF_WALKER_ANDROID_MANUAL_EN_URL,
    DF_WALKER_ANDROID_MANUAL_JA_URL,
    DF_WALKER_IOS_MANUAL_EN_URL,
    DF_WALKER_IOS_MANUAL_JA_URL,
    RECOMMENDED_UAV_FLIGHT_FILENAME_EN,
    RECOMMENDED_UAV_FLIGHT_FILENAME_JA,
    RECOMMENDED_UAV_FLIGHT_URL_EN,
    RECOMMENDED_UAV_FLIGHT_URL_JA,
} from "../consts/Installers";
import i18n from "../i18n/configs";
import { Helmet } from "react-helmet";
import DFWalkerAndroidDownloadModal from "./modals/DFWalkerAndroidDownloadModal";
import DFWalkerIOSDownloadModal from "./modals/DFWalkerIOSDownloadModal";

const DF_SCANNER_VAL = 1;
const DF_VIEWER_VAL = 2;
const DF_LAT_VAL = 3;
const DF_BIRD_VAL = 4;

/**
 * ダウンロード画面
 * @returns JSX.Element
 */
const Download = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showDFWalkerAndroidDownloadModal, setShowDFWalkerAndroidDownloadModal] = useState(false);
    const [showDFWalkerIOSDownloadModal, setShowDFWalkerIOSDownloadModal] = useState(false);

    /**
     * 商品選択時のイベント処理
     * @param event
     */
    const handleSelectProduct: MouseEventHandler<HTMLButtonElement> = () => {
        // 商品選択画面へ
        // ※購入内容確認画面の前に所在地確認を入れたいため商品選択画面に移動させる
        navigate(PRODUCT_SELECT_ROUTE);
    };

    /**
     * DF Walker [Andoird] ダウンロード用モーダルを開く
     */
    const handleOpenDFWalkerAndroidDownloadModal = () => {
        setShowDFWalkerAndroidDownloadModal(true);
    };

    /**
     * DF Walker [Andorid] ダウンロード用モーダルを閉じる
     */
    const handleCloseDFWalkerAndroidDownloadModal = () => {
        setShowDFWalkerAndroidDownloadModal(false);
    };

    /**
     * DF Walker [iOS] ダウンロード用モーダルを開く
     */
    const handleOpenDFWalkerIOSDownloadModal = () => {
        setShowDFWalkerIOSDownloadModal(true);
    };

    /**
     * DF Walker [iOS] ダウンロード用モーダルを閉じる
     */
    const handleCloseDFWalkerIOSDownloadModal = () => {
        setShowDFWalkerIOSDownloadModal(false);
    };

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet>
                <title>{t("Download.meta.title")}</title>
                <meta name="description" content={t("Download.meta.description")} />
            </Helmet>
            <ScrollToTop />
            <DFNavbar bottomPadding={true} />
            <div className="bg-white pb-10 pt-20">
                <div className="mx-auto max-w-screen-md px-4 md:px-8">
                    <div className="flex items-center justify-center">
                        <h1 className="mb-2 mt-2 text-center text-2xl font-bold text-gray-800 sm:text-3xl">
                            {t("Download.title")}
                        </h1>
                    </div>

                    <div className="mt-2 flex items-center justify-center">
                        <a
                            className="text-center text-sm font-bold text-red-600  sm:text-base"
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforestlicense.com/docs/smartscreen-guide-ja.pdf"
                                    : "https://deepforestlicense.com/docs/smartscreen-guide-en.pdf"
                            }
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            {t("Download.importantNotice")}
                        </a>
                    </div>
                    <div className="flex items-center justify-center">
                        <a
                            className="text-center text-sm text-red-600 underline md:text-base"
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforestlicense.com/docs/smartscreen-guide-ja.pdf"
                                    : "https://deepforestlicense.com/docs/smartscreen-guide-en.pdf"
                            }
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            {t("Download.windowsSecurityGuide1")}
                        </a>
                    </div>
                    <div className="mb-8 flex items-center justify-center">
                        <a
                            className="text-center text-sm text-red-600 underline md:text-base"
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforestlicense.com/docs/smartappcontrol-ja.pdf"
                                    : "https://deepforestlicense.com/docs/smartappcontrol-en.pdf"
                            }
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            {t("Download.windowsSecurityGuide2")}
                        </a>
                    </div>

                    {/* DF Scanner */}
                    <div className="flex items-center">
                        <img className="h-16 w-16 p-1" src={dfscanner_icon} alt="dfscanner" />
                        <h2 id="dfscanner" className="pl-2 text-3xl font-semibold text-gray-800 sm:text-4xl">
                            DF Scanner
                        </h2>
                        <label className="pl-2 text-3xl font-semibold text-gray-800 sm:text-4xl">
                            {t("CommonLabel.pro")} / {t("CommonLabel.lite")}
                        </label>
                    </div>
                    <p className="mb-2 py-2 pl-2 text-lg">{t("Download.dfscanner.about")}</p>
                    <table className="min-w-full border border-gray-300">
                        <tbody>
                            {/* Pro版 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-2 text-center text-sm font-bold text-lime-800">
                                    {t("CommonLabel.pro")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">DF Scanner Pro</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_PRO_URL}
                                    >
                                        {DF_SCANNER_PRO_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* AI樹冠分離モデル */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-2 text-center text-sm font-bold text-lime-800">
                                    {t("CommonLabel.pro")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2 ">
                                    {t("Download.dfscanner.AISegmentationModelLabel")}
                                    <label className="text-xs font-bold">
                                        &nbsp;*{t("Download.dfscanner.onlyPro")}
                                    </label>
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const confirmed = window.confirm(
                                                t("Download.dfscanner.AISegmentationModelConfirm"),
                                            );
                                            if (confirmed) {
                                                // ダウンロードを実行
                                                window.location.href = AI_SEGMENTATION_MODEL_URL;
                                            }
                                        }}
                                    >
                                        {AI_SEGMENTATION_MODEL_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* Pro版 ユーザーマニュアル */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-center text-sm font-bold text-lime-800">
                                    {t("CommonLabel.pro")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">
                                    {t("Download.dfscanner.userManual")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_PRO_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_SCANNER_PRO_MANUAL_JA_FILENAME}
                                    </a>
                                    <br />
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_PRO_MANUAL_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_SCANNER_PRO_MANUAL_EN_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* 利用規約 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-center text-sm font-bold text-lime-800">
                                    {t("CommonLabel.pro")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.termsOfUse")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_PRO_TERMS_OF_USE_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        日本語
                                    </a>
                                    <span className="text-gray-500">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_PRO_TERMS_OF_USE_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        English
                                    </a>
                                </td>
                            </tr>

                            {/* Lite版 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-2 text-center text-sm font-bold text-lime-500">
                                    {t("CommonLabel.lite")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">DF Scanner Lite</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_LITE_URL}
                                    >
                                        {DF_SCANNER_LITE_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* Lite版 ユーザーマニュアル */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-center text-sm font-bold text-lime-500">
                                    {t("CommonLabel.lite")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">
                                    {t("Download.dfscanner.userManual")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_LITE_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_SCANNER_LITE_MANUAL_JA_FILENAME}
                                    </a>
                                    <br />
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_LITE_MANUAL_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_SCANNER_LITE_MANUAL_EN_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* 利用規約 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-2 text-center text-sm font-bold text-lime-500">
                                    {t("CommonLabel.lite")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.termsOfUse")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_LITE_TERMS_OF_USE_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        日本語
                                    </a>
                                    <span className="text-gray-500">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_LITE_TERMS_OF_USE_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        English
                                    </a>
                                </td>
                            </tr>

                            {/* ドローン計測の推奨諸元について */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-sm font-bold text-lime-700"></td>
                                <td className="border border-gray-300 px-4 py-1">
                                    {t("Download.dfscanner.recommendedFlight")}
                                    <br />
                                    <div className="text-xs font-bold text-gray-600">
                                        *{t("Download.dfscanner.readThis")}
                                    </div>
                                </td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={RECOMMENDED_UAV_FLIGHT_URL_JA}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {RECOMMENDED_UAV_FLIGHT_FILENAME_JA}
                                    </a>
                                    <span className="text-gray-500">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={RECOMMENDED_UAV_FLIGHT_URL_EN}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {RECOMMENDED_UAV_FLIGHT_FILENAME_EN}
                                    </a>
                                </td>
                            </tr>

                            {/* サンプルデータ */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-2 text-sm font-bold text-lime-700"></td>
                                <td className="border border-gray-300 px-4 py-2">
                                    {t("Download.dfscanner.sampleData")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_SCANNER_TESTDATA_URL}
                                    >
                                        {DF_SCANNER_TESTDATA_FILENAME}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <p className="mt-5 text-base text-gray-800">
                        <label className="">{t("Download.dfscanner.aboutAISegmentationModel")}</label>
                        <ul className="ml-5 list-disc text-sm">
                            <li>
                                <Trans
                                    i18nKey="Download.dfscanner.aboutAISegmentationModelText1"
                                    components={{
                                        l: <label className="font-bold" />,
                                    }}
                                />
                            </li>
                            <li>
                                <Trans
                                    i18nKey="Download.dfscanner.aboutAISegmentationModelText2"
                                    components={{
                                        l: <label className="font-bold" />,
                                    }}
                                />
                            </li>
                            <li>
                                <Trans
                                    i18nKey="Download.dfscanner.aboutAISegmentationModelText3"
                                    components={{
                                        l: <label className="font-bold" />,
                                    }}
                                />
                            </li>
                        </ul>
                    </p>

                    <p className="mt-5 text-base text-gray-800"></p>

                    <p className="text-base text-gray-800">
                        <Trans
                            i18nKey="Download.dfscanner.aboutDfbird"
                            components={{
                                l: <label className="font-bold" />,
                            }}
                        />
                    </p>

                    {/* DF Scanner ライセンス購入 */}
                    <p className="mb-2 mt-6 text-gray-700">
                        ◇&nbsp;
                        <Trans
                            i18nKey="Download.dfscanner.purchaseLicensesText1"
                            components={{
                                l: <button className="link-text" onClick={handleSelectProduct} />,
                            }}
                        />
                    </p>
                    {/* リリースノート */}
                    <p className="mb-2 mt-2 text-gray-700">
                        ◇&nbsp;
                        <Link to={RELEASE_NOTES_ROUTE} state={{ productValue: DF_SCANNER_VAL }}>
                            <Trans
                                i18nKey="Download.releaseHistory"
                                components={{
                                    l: <button className="link-text" />,
                                }}
                            />
                        </Link>
                    </p>

                    {/* 詳細ページへのリンク */}
                    <div className="mx-auto flex items-center justify-center">
                        <a
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforest-tech.co.jp/df-scanner/"
                                    : "https://deepforest-tech.co.jp/en/df-scanner/"
                            }
                            className="link-text mt-2 text-lg"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {i18n.language === "ja"
                                ? "DF Scannerの紹介ページはこちら"
                                : "Check out the DF Scanner introduction"}
                        </a>
                    </div>

                    <hr className="mb-4 mt-16 border-2"></hr>

                    {/* DF Viewer */}
                    <div className="flex items-center">
                        <img className="h-16 w-16 p-1" src={dfviewer_icon} alt="dfviewer" />
                        <h2 id="dfviewer" className="pl-2 text-3xl font-semibold text-gray-800 sm:text-4xl">
                            DF Viewer
                        </h2>
                    </div>
                    <p className="mb-2 py-2 pl-2 text-lg">{t("Download.dfviewer.about")}</p>
                    <table className="min-w-full border border-gray-300">
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">DF Viewer</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_VIEWER_URL}
                                    >
                                        {DF_VIEWER_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">
                                    {t("Download.dfviewer.userManual")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_VIEWER_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_VIEWER_MANUAL_JA_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* 利用規約 */}
                            <tr>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.termsOfUse")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_VIEWER_TERMS_OF_USE_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        日本語
                                    </a>
                                    <span className="text-gray-500">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_VIEWER_TERMS_OF_USE_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        English
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* リリースノート */}
                    <p className="mb-2 mt-6 text-gray-700">
                        ◇&nbsp;
                        <Link to={RELEASE_NOTES_ROUTE} state={{ productValue: DF_VIEWER_VAL }}>
                            <Trans
                                i18nKey="Download.releaseHistory"
                                components={{
                                    l: <button className="link-text" />,
                                }}
                            />
                        </Link>
                    </p>

                    {/* 詳細ページへのリンク */}
                    <div className="mx-auto flex items-center justify-center">
                        <a
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforest-tech.co.jp/df-viewer/"
                                    : "https://deepforest-tech.co.jp/en/df-viewer/"
                            }
                            className="link-text mt-2 text-lg"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {i18n.language === "ja"
                                ? "DF Viewerの紹介ページはこちら"
                                : "Check out the DF Viewer introduction"}
                        </a>
                    </div>

                    <hr className="mb-4 mt-16 border-2"></hr>

                    {/* DF LAT */}
                    <div className="flex items-center">
                        <img className="h-16 w-16 p-1" src={dflat_icon} alt="dflat" />
                        <h2 id="dflat" className="pl-2 text-3xl font-semibold text-gray-800 sm:text-4xl">
                            DF LAT
                        </h2>
                        <label className="pl-2 text-3xl font-semibold text-gray-800 sm:text-4xl">
                            {t("CommonLabel.pro")} / {t("CommonLabel.lite")}
                        </label>
                    </div>
                    <p className="mb-2 py-2 pl-2 text-lg">{t("Download.dflat.about")}</p>
                    <table className="min-w-full border border-gray-300">
                        <tbody>
                            {/*  DF LAT Pro版 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-2 text-center text-sm font-bold text-lime-800">
                                    {t("CommonLabel.pro")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">DF LAT Pro</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_PRO_URL}
                                    >
                                        {DF_LAT_PRO_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/*  DF LAT Pro版 ユーザーマニュアル */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-center text-sm font-bold text-lime-800">
                                    {t("CommonLabel.pro")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.dflat.userManual")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_PRO_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_LAT_PRO_MANUAL_JA_FILENAME}
                                    </a>
                                    <br />
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_PRO_MANUAL_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_LAT_PRO_MANUAL_EN_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* 利用規約 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-center text-sm font-bold text-lime-800">
                                    {t("CommonLabel.pro")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.termsOfUse")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_PRO_TERMS_OF_USE_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        日本語
                                    </a>
                                    <span className="text-gray-500">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_PRO_TERMS_OF_USE_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        English
                                    </a>
                                </td>
                            </tr>

                            {/* Lite版 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-2 text-center text-sm font-bold text-lime-500">
                                    {t("CommonLabel.lite")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">DF LAT Lite</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_LITE_URL}
                                    >
                                        {DF_LAT_LITE_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-center text-sm font-bold text-lime-500">
                                    {t("CommonLabel.lite")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.dflat.userManual")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_LITE_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_LAT_LITE_MANUAL_JA_FILENAME}
                                    </a>
                                    <br />
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_LITE_MANUAL_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_LAT_LITE_MANUAL_EN_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* 利用規約 */}
                            <tr>
                                <td className="border border-gray-300 px-1 py-1 text-center text-sm font-bold text-lime-500">
                                    {t("CommonLabel.lite")}
                                </td>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.termsOfUse")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_LITE_TERMS_OF_USE_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        日本語
                                    </a>
                                    <span className="text-gray-500">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_LAT_LITE_TERMS_OF_USE_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        English
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <p className="mt-5 text-sm text-gray-800">
                        <Trans
                            i18nKey="Download.dflat.v2UpdateNote"
                            components={{
                                l: <label className="font-bold" />,
                            }}
                        />
                    </p>

                    {/* DF LAT ライセンス購入 */}
                    <p className="mb-2 mt-4 text-gray-700">
                        ◇&nbsp;
                        <Trans
                            i18nKey="Download.dflat.purchaseLicensesText1"
                            components={{
                                l: <button className="link-text" onClick={handleSelectProduct} />,
                            }}
                        />
                    </p>
                    {/* リリースノート */}
                    <p className="mb-2 mt-2 text-gray-700">
                        ◇&nbsp;
                        <Link to={RELEASE_NOTES_ROUTE} state={{ productValue: DF_LAT_VAL }}>
                            <Trans
                                i18nKey="Download.releaseHistory"
                                components={{
                                    l: <button className="link-text" />,
                                }}
                            />
                        </Link>
                    </p>

                    {/* 詳細ページへのリンク */}
                    <div className="mx-auto flex items-center justify-center">
                        <a
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforest-tech.co.jp/df-lat/"
                                    : "https://deepforest-tech.co.jp/en/df-lat/"
                            }
                            className="link-text mt-2 text-lg"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {i18n.language === "ja"
                                ? "DF LATの紹介ページはこちら"
                                : "Check out the DF LAT introduction"}
                        </a>
                    </div>

                    <hr className="mb-4 mt-16 border-2"></hr>

                    {/* DF Walker */}
                    <div className="flex items-center">
                        <img className="h-16 w-16 p-1" src={dfwalker_icon} alt="dfwalker" />
                        <h2 id="dfwalker" className="pl-2 text-3xl font-semibold text-gray-800 sm:text-4xl">
                            DF Walker
                        </h2>
                    </div>
                    <p className="mb-2 py-2 pl-2 text-lg">{t("Download.dfwalker.about")}</p>
                    <table className="min-w-full border border-gray-300">
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">DF Walker [Android]</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <button
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        onClick={handleOpenDFWalkerAndroidDownloadModal}
                                    >
                                        {t("Download.dfwalker.displayQRCode")}
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">DF Walker [iOS]</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <button
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        onClick={handleOpenDFWalkerIOSDownloadModal}
                                    >
                                        {t("Download.dfwalker.displayQRCode")}
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">
                                    {t("Download.dfwalker.userManual") + "[Android]"}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_WALKER_ANDROID_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        DF Walker ユーザーマニュアル.pdf
                                    </a>
                                    <br />
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_WALKER_ANDROID_MANUAL_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        DF Walker User's Guide.pdf
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">
                                    {t("Download.dfwalker.userManual") + "[iOS]"}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_WALKER_IOS_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        DF Walker ユーザーマニュアル.pdf
                                    </a>
                                    <br />
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_WALKER_IOS_MANUAL_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        DF Walker User's Guide.pdf
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* 詳細ページへのリンク */}
                    <div className="mx-auto mt-4 flex items-center justify-center">
                        <a
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforest-tech.co.jp/df-walker/"
                                    : "https://deepforest-tech.co.jp/en/df-walker/"
                            }
                            className="link-text mt-2 text-lg"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {i18n.language === "ja"
                                ? "DF Walkerの紹介ページはこちら"
                                : "Check out the DF Walker introduction"}
                        </a>
                    </div>

                    <hr className="mb-4 mt-16 border-2"></hr>

                    {/* DF BIRD */}
                    <div className="flex items-center">
                        <img className="h-16 w-16 p-1" src={dfbird_icon} alt="dfbird" />
                        <h2 id="dfbird" className="pl-2 text-3xl font-semibold text-gray-800 sm:text-4xl">
                            DF BIRD
                        </h2>
                    </div>
                    <p className="mb-2 py-2 pl-2 text-lg">{t("Download.dfbird.about")}</p>
                    <table className="min-w-full border border-gray-300">
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">DF BIRD</td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_BIRD_URL}
                                    >
                                        {DF_BIRD_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 px-4 py-2">
                                    {t("Download.dfviewer.userManual")}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_BIRD_MANUAL_JA_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_BIRD_MANUAL_JA_FILENAME}
                                    </a>
                                    <br />
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_BIRD_MANUAL_EN_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {DF_BIRD_MANUAL_EN_FILENAME}
                                    </a>
                                </td>
                            </tr>
                            {/* 利用規約 */}
                            <tr>
                                <td className="border border-gray-300 px-4 py-1">{t("Download.license")}</td>
                                <td className="border border-gray-300 px-4 py-1">
                                    <a
                                        className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                                        href={DF_BIRD_LICENSE_URL}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {t("Download.license")}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* リリースノート */}
                    <p className="mb-2 mt-4 text-gray-700">
                        ◇&nbsp;
                        <Link to={RELEASE_NOTES_ROUTE} state={{ productValue: DF_BIRD_VAL }}>
                            <Trans
                                i18nKey="Download.releaseHistory"
                                components={{
                                    l: <button className="link-text" />,
                                }}
                            />
                        </Link>
                    </p>

                    {/* 詳細ページへのリンク */}
                    <div className="mx-auto mb-20 flex items-center justify-center">
                        <a
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforest-tech.co.jp/df-bird/"
                                    : "https://deepforest-tech.co.jp/en/df-bird/"
                            }
                            className="link-text mt-2 text-lg"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {i18n.language === "ja"
                                ? "DF BIRDの紹介ページはこちら"
                                : "Check out the DF BIRD introduction"}
                        </a>
                    </div>
                </div>
            </div>
            {/* DF Walkerダウンロード用モーダル[Android] */}
            <DFWalkerAndroidDownloadModal
                showModal={showDFWalkerAndroidDownloadModal}
                handleClose={handleCloseDFWalkerAndroidDownloadModal}
            />
            {/* DF Walkerダウンロード用モーダル[iOS] */}
            <DFWalkerIOSDownloadModal
                showModal={showDFWalkerIOSDownloadModal}
                handleClose={handleCloseDFWalkerIOSDownloadModal}
            />
            <Footer />
        </div>
    );
};

export default Download;
